import { partner } from '../../api/partner';
import type { TripFull } from '../../api/types';
import { useT } from '../../i18n';
import { useFormat } from '../../lib/format';
import { useAsync } from '../../lib/useAsync';
import { docNames } from '../../lib/vehicleDocs';

/** «Рейс не зможе виїхати»: a planned trip whose vehicle lacks a mandatory document (the API blocks departure). */
export function DepartureBlock({ check }: { check: TripFull['departure_check'] }) {
  const t = useT();
  const f = useFormat();
  if (!check?.blocked) return null;
  return (
    <p role="alert" className="mt-2 rounded-xl border border-bad px-3 py-2 text-[15px] text-bad" data-testid="departure-blocked">
      {t('trips.departureBlocked', { docs: docNames(check.problems, f.locale) })}
    </p>
  );
}

/** Loads the trip and shows {@link DepartureBlock} — for lists that only have the trip id (handover «Cursa» block). */
export function DepartureWarning({ tripId }: { tripId: string }) {
  const q = useAsync(() => partner.trip(tripId), [tripId]);
  return <DepartureBlock check={q.data?.departure_check} />;
}
